import { collection, doc, getDoc, setDoc } from 'firebase/firestore';
import React from 'react'
import { db } from './firebaseConfig';
import { useNavigate } from 'react-router-dom';

function StartThis() {


  const [guestId, setGuestId] = React.useState("");
  const navigate = useNavigate();

  React.useEffect(() => {
    const doSomething = async () => {

      async function createNewGuestAndNavigate() {
        const newDocRef = doc(collection(db, 'guest'));

        var guestData = { "name": "", answers: [] }

        await setDoc(newDocRef, guestData);

        localStorage.setItem('guestDocumentId', newDocRef.id);

        navigate(`/guest-access/${newDocRef.id}`)

      }

      if (localStorage.getItem('guestDocumentId')) {
        var tempId = localStorage.getItem('guestDocumentId');

        const guestDocRef = doc(db, 'guest', tempId);
        const guestDocSnap = await getDoc(guestDocRef);

        if (!guestDocSnap.exists()) {
          await createNewGuestAndNavigate();
        }
        else {
          setGuestId(tempId);
          navigate(`/guest-access/${tempId}`)
        }

      }
      else {
        await createNewGuestAndNavigate();
      }
    }

    doSomething();


  }, [navigate]);


  return (
    <div>{guestId}</div>
  )
}

export default StartThis


